export default "__VITE_ASSET__C76y9im2__"